import { createFeature, createReducer, on } from '@ngrx/store';
import { MeetingNotesActions } from '@store/actions/meeting-notes/meeting-notes.actions';
import { MeetingNote } from '@models/meeting-notes.model';

export const meetingNotesFeatureKey = 'meeting-notes';

export interface State {
  notes: MeetingNote[];
  loading: boolean;
  uploading: boolean;
  deleting: boolean;
  viewing: boolean;
  uploadModalOpen: boolean;
  error: string | null;
}

export const initialState: State = {
  notes: [],
  loading: false,
  uploading: false,
  deleting: false,
  viewing: false,
  uploadModalOpen: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(MeetingNotesActions.loadMeetingNotes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MeetingNotesActions.loadMeetingNotesSuccess, (state, { notes }) => ({
    ...state,
    notes,
    loading: false,
    error: null,
  })),
  on(MeetingNotesActions.loadMeetingNotesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(MeetingNotesActions.uploadMeetingNote, (state) => ({
    ...state,
    uploading: true,
    error: null,
  })),
  on(MeetingNotesActions.uploadMeetingNoteSuccess, (state) => ({
    ...state,
    uploading: false,
    uploadModalOpen: false,
    error: null,
  })),
  on(MeetingNotesActions.uploadMeetingNoteFailure, (state, { error }) => ({
    ...state,
    uploading: false,
    error,
  })),

  on(MeetingNotesActions.deleteMeetingNote, (state) => ({
    ...state,
    deleting: true,
    error: null,
  })),
  on(MeetingNotesActions.deleteMeetingNoteSuccess, (state, { id }) => ({
    ...state,
    notes: state.notes.filter((n) => n.id !== id),
    deleting: false,
    error: null,
  })),
  on(MeetingNotesActions.deleteMeetingNoteFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error,
  })),

  on(MeetingNotesActions.viewMeetingNote, (state) => ({
    ...state,
    viewing: true,
    error: null,
  })),
  on(MeetingNotesActions.viewMeetingNoteSuccess, (state) => ({
    ...state,
    viewing: false,
    error: null,
  })),
  on(MeetingNotesActions.viewMeetingNoteFailure, (state, { error }) => ({
    ...state,
    viewing: false,
    error,
  })),

  on(MeetingNotesActions.openUploadModal, (state) => ({
    ...state,
    uploadModalOpen: true,
  })),
  on(MeetingNotesActions.closeUploadModal, (state) => ({
    ...state,
    uploadModalOpen: false,
  }))
);

export const meetingNotesFeature = createFeature({
  name: meetingNotesFeatureKey,
  reducer,
});
